import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import useTooltipPosition from './useTooltipPosition'

import styles from './styles'

const BaseTooltip = ({
  isOpen,
  initialPosition,
  initialTooltipAlign,
  tooltipContent,
  children,
  overflow = 'scroll',
  bgColor
}) => {
  const tooltipElem = useRef(null)

  const { position, tooltipAlign } = useTooltipPosition({
    isOpen,
    initialPosition,
    initialTooltipAlign,
    tooltipElem: tooltipElem.current
  })

  if (!tooltipContent) {
    return children
  }

  return (
    <div className="base-tooltip-container">
      <div
        className={classnames(
          'tooltip-container',
          `tooltip-position-${position}`,
          `tooltip-align-${tooltipAlign}`,
          {
            'is-open': isOpen
          }
        )}
      >
        <div
          className={classnames(
            'tooltip-arrow',
            `tooltip-arrow-bg-${bgColor}`,
            `tooltip-arrow-align-${position}-${tooltipAlign}`
          )}
        />
        <div
          ref={tooltipElem}
          className={classnames('tooltip-content', `bg-${bgColor}`, `overflow-${overflow}`)}
        >
          {tooltipContent}
        </div>
      </div>
      {children}

      <style jsx>{styles}</style>
    </div>
  )
}

BaseTooltip.defaultProps = {
  bgColor: 'frame',
  initialPosition: 'top',
  overflow: 'scroll',
  initialTooltipAlign: 'right'
}

BaseTooltip.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  tooltipContent: PropTypes.oneOfType([PropTypes.element, PropTypes.any]),
  initialPosition: PropTypes.oneOf(['top', 'bottom']),
  initialTooltipAlign: PropTypes.oneOf(['left', 'right']),
  overflow: PropTypes.oneOf(['auto', 'scroll']),
  bgColor: PropTypes.oneOf(['frame'])
}

export default BaseTooltip
